import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {endpoints} from '../../../configs/endpoints/endpoint';
import {CommonService} from '@service/common/common.service';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AcademyService {

  constructor(private httpClient: HttpClient, private common: CommonService) {
  }

  public getCatalogImage(model: any): any {
    return this.getImages({modelCode: model?.modelCode, modelElementCode: null, fixedOne: true}).pipe(
      map((result: any) => {
        if (result?.success && result?.data?.imagePathList?.length > 0) {
          return result?.data[0].image_url;
        } else {
          return [ model?.imagePath, '?dimension=hd'].join('');
        }
      }));
  }

  public getCatalogSearchImage(model: any): any {
    return this.getImages({
      modelCode: model?.modelCode,
      modelElementCode: model?.modelElementCode,
      fixedOne: true
    }).pipe(
      (result: any) => {
        if (result?.success && result?.data?.length > 0) {
          return result?.data[0].image_url;
        } else {
          const images: any = this.extractOtherImages(model);
          if (images.length) {
            return images[0];
          } else {
            return [ model?.imagePath, '?dimension=hd'].join('');
          }
        }
      });
  }

  public async getModelImages(model: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.getImages({
        modelCode: model?.modelCode,
        modelElementCode: model.fixedOne ? model?.modelElementCode : null,
        fixedOne: model?.fixedOne ? model?.fixedOne : false
      }).subscribe((result: any) => {
        let images: any[] = [];
        if (result?.success && result?.data?.length > 0) {
          images = result?.data.map((image: any) => image.image_url);
        } else if (!model?.fixedOne) {
          images = this.extractImages(model, true);
        } else if (images?.length === 0 && model?.fixedOne) {
          const otherImages: any = this.extractOtherImages(model);
          if (otherImages.length) {
            images.push(otherImages[0]);
          } else {
            const path = [ model?.imagePath, '?dimension=hd'].join('');
            images.push(path);
          }
        }
        resolve(images);
      });
    });
  }

  public getModelElementImage(model: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const body = {
        modelCode: model?.modelCode,
        modelElementCode: model?.productCode,
        fixedOne: true
      };
      this.getImages(body).subscribe((result: any) => {
        let images: any[] = [];
        if (result?.success && result?.data?.length > 0) {
          images = result?.data.map((image: any) => image.image_url);
        } else {
          images = this.extractImages(model, true);
        }
        if (!images.length) {
          images = this.extractImages(model, true);
        }
        resolve(images);
      });
    });
  }

  public getImages(params?: any): Observable<any> {
    const url = this.common.composeUrl([endpoints.academy.images], null);
    return this.httpClient.post<any>(url, params).pipe(
      map((response) => {
        return response.result;
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  private extractImages(model: any, skipImagePath: boolean): any[] {
    let images: any[] = [];
    images = images.concat(this.extractOtherImages(model));
    if (model?.imagePath && (!skipImagePath || images.length === 0)) {
      images.push({imagePath: model?.imagePath, isTechnical: false});
    }
    return images;
  }

  private extractOtherImages(model: any): any[] {
    let images: any[] = [];
    if (model?.images) {
      images = images.concat(model?.images);
    }
    if (model?.ext_links) {
      images = images.concat(model?.ext_links);
    }
    return images;
  }

}
